// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useContext } from "react";

import { AuthContext } from "./AuthContext";

export const useAuth = () => useContext(AuthContext);
